import { render } from "./poids_corps.vue?vue&type=template&id=36e90a9e&scoped=true&ts=true"
import script from "./poids_corps.vue?vue&type=script&lang=ts"
export * from "./poids_corps.vue?vue&type=script&lang=ts"

import "./poids_corps.vue?vue&type=style&index=0&id=36e90a9e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36e90a9e"]])

export default __exports__